/** Metric card config for Events summary — values come from /admin/event-metrics. */
export const EVENT_METRIC_CONFIG = [
  {
    id: 'total-events',
    label: 'Total Events',
    key: 'totalEvents',
    tooltip: 'Total number of events created in the selected period',
  },
  {
    id: 'total-guests',
    label: 'Total Guests',
    key: 'totalGuests',
    tooltip: 'Total guests across all events in the selected period',
  },
  {
    id: 'total-revenue',
    label: 'Total Revenue',
    key: 'totalRevenue',
    valuePrefix: 'AED ',
    tooltip: 'Total revenue from events in the selected period',
    formatValue: (value) =>
      Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }),
  },
];

export const buildEventsSummaryMetrics = (metrics) =>
  EVENT_METRIC_CONFIG.map((cfg) => {
    const raw = metrics?.[cfg.key];
    const value = Number(raw) || 0;

    return {
      id: cfg.id,
      label: cfg.label,
      value,
      tooltip: cfg.tooltip,
      valuePrefix: cfg.valuePrefix ?? '',
      formatValue: cfg.formatValue,
    };
  });
